import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'react-quill/dist/quill.snow.css';
import 'nprogress/nprogress.css';
import 'src/assets/css/prism.css';
import 'src/mixins/chartjs';
import 'src/mixins/prismjs';
import { enableES5 } from 'immer';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import * as serviceWorker from 'src/serviceWorker';
import { SettingsProvider } from 'src/context/SettingsContext';
import { configureStore } from 'src/store';
import { restoreSettings } from 'src/utils/settings';
import { loadState } from './utils/localStorage';
import App from 'src/App';
import TagManager from 'react-gtm-module'

enableES5();
const persistedState = loadState()
const store = configureStore(persistedState);

const settings = restoreSettings();
const tagManagerArgs = {
    // gtmId: 'GTM-N5XBJZQ´ Development
    // gtmId: 'GTM-WHB5LQ7' Production.
    gtmId: process.env.REACT_APP_ARRK_CONTAINER_ID
}
console.log(tagManagerArgs)

TagManager.initialize(tagManagerArgs)

ReactDOM.render(
    <Provider store={store}>
        <SettingsProvider settings={settings}>
            <App />
        </SettingsProvider>
    </Provider>,
    document.getElementById('root')
);

serviceWorker.unregister();
